const hamburgers = Array.from(document.querySelectorAll(".hamburger"));
const sidebarBg = document.querySelector(".sidebar-bg");
const sidebar = document.querySelector(".sidebar");
const sidebarClose = document.querySelector(".sidebar-tenant-collapse");
const body = document.body;
const searchBtn = Array.from(document.querySelectorAll(".search-btn"));
const searchForm = document.querySelector(".search-form");
const searchFormClose = document.querySelector(".search-form__close");

function openSidebar() {
  sidebarBg.classList.add("open");
  sidebar.classList.add("open");
  body.classList.add("sidebar-is-open");
  body.style.overflow = "hidden";
}

function closeSidebar() {
  sidebarBg.classList.remove("open");
  sidebar.classList.remove("open");
  body.classList.remove("sidebar-is-open");
  body.style.overflow = null;
}

hamburgers.forEach(function(hamburger) {
  hamburger.addEventListener('click', function() {
    if (sidebar.classList.contains("open")) {
      closeSidebar();
    } else {
      openSidebar();
    }
  });
});

sidebarBg.addEventListener('click', function() {
  closeSidebar();
});

/* 閉じるボタンは block 化で複数・任意配置になったため委譲で拾う */
if (sidebar) {
  sidebar.addEventListener('click', function(event) {
    if (event.target.closest('.sidebar-tenant-collapse')) {
      closeSidebar();
    }
  });
}

searchFormClose?.addEventListener('click', function(event) {
  searchForm.classList.remove("open");
  event.stopPropagation();
});

searchForm?.addEventListener('click', function(event) {
  event.stopPropagation();
});

body.addEventListener('click', function(event) {
  if (searchBtn.some(function(btn) { return btn.contains(event.target); })) {
    return;
  }
  if (searchForm && searchForm.classList.contains("open")) {
    searchForm.classList.remove("open");
  }
});

searchBtn.forEach(function(element) {
  element.addEventListener('click', function(event) {
    if (!searchForm.classList.contains("open")) {
      searchForm.classList.add("open");
    }
    event.stopPropagation();
  });
});

const searchSidebarBg = document.querySelector(".search-sidebar-bg");
const searchSidebar = document.querySelector(".search-sidebar");
if (searchSidebarBg && searchSidebar) {
  const searchSidebarToggles = Array.from(document.querySelectorAll(".search-sidebar-toggle"));

  const openSearchSidebar = function() {
    searchSidebarBg.classList.add("open");
    searchSidebar.classList.add("open");
    body.classList.add("search-sidebar-is-open");
    body.style.overflow = "hidden";
  };

  const closeSearchSidebar = function() {
    searchSidebarBg.classList.remove("open");
    searchSidebar.classList.remove("open");
    body.classList.remove("search-sidebar-is-open");
    body.style.overflow = null;
  };

  searchSidebarToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      if (searchSidebar.classList.contains("open")) {
        closeSearchSidebar();
      } else {
        openSearchSidebar();
      }
    });
  });

  searchSidebarBg.addEventListener('click', function() {
    closeSearchSidebar();
  });

  /* 閉じるボタン（旧 .search-sidebar-tenant-collapse / 共通 .sidebar-tenant-collapse）を委譲で拾う */
  searchSidebar.addEventListener('click', function(event) {
    if (event.target.closest('.sidebar-tenant-collapse, .search-sidebar-tenant-collapse')) {
      closeSearchSidebar();
    }
  });
}
